import { ArrowRightIcon, BasicListItem, Box, Flex, Link, Text } from "@shared/primitive-components"
import { formatPercentage } from "@shared/utils/formatters/formatPercentage"
import { navigationWithAltClick } from "@shared/utils/helpers/navigationWithAltClick"
import { buildHrefLinkForRows } from "@shared/utils/helpers/buildHrefLinkForRows"
import { PeriodVehicle } from "../../../../api/insights/periods/types"
import { PATHS } from "../../../../const/paths"
import { worstSpeedersItemStyles as styles } from "../../../styles"
import { MaybeObfuscatedValue } from "../../../../components/Obfuscated"

export type WorstSpeederItemProps = {
  item: PeriodVehicle
  index: number
}

export const WORST_SPEEDER_ITEM_DTI = {
  NUMBER: `minor-line`,
  VRN: `major-line`,
  NAME: `critical-line`,
  DISTANCE_SPEEDING: `distance-speeding`,
  AVG_EXCEEDANCE: `avg-exceedance`,
}

export const WorstSpeederItem = ({ item, index }: WorstSpeederItemProps) => (
  <BasicListItem css={styles.listItem}>
    <Link
      onClick={(e: React.MouseEvent<HTMLElement>) =>
        navigationWithAltClick(
          `${PATHS.INSIGHTS.VEHICLES}/${item.vrn.replace(/\s/g, ``)}/trips`,
          e,
          `${window.location.href.replace(/\?.*/, ``)}/..`,
          true
        )
      }
      href={buildHrefLinkForRows(
        `${PATHS.INSIGHTS.BASE}/${PATHS.INSIGHTS.VEHICLES}`,
        `${item.vrn.replace(/\s/g, ``)}/trips`
      )}
      css={styles.link}
    >
      <Flex css={styles.listItemInner}>
        <Flex css={styles.itemDetails}>
          <Text tag="h2" css={styles.number} data-testid={WORST_SPEEDER_ITEM_DTI.NUMBER}>
            {index}
          </Text>
          <Box css={styles.marginRight}>
            <Text tag="h3" css={styles.vrn} data-testid={WORST_SPEEDER_ITEM_DTI.VRN}>
              <MaybeObfuscatedValue type="vrn" value={item.vrn} />
            </Text>
            <Text css={styles.caption} data-testid={WORST_SPEEDER_ITEM_DTI.NAME}>
              {item.name}
            </Text>
          </Box>
          <Box css={styles.rightIconWrap}>
            <ArrowRightIcon width="20" height="20" />
          </Box>
        </Flex>
        <Box>
          {!!item.distanceSpentSpeeding && (
            <Flex css={styles.speedPercentages}>
              <Text tag="h2" css={styles.largeText} data-testid={WORST_SPEEDER_ITEM_DTI.DISTANCE_SPEEDING}>
                {formatPercentage(item.distanceSpentSpeeding, 1)}
              </Text>
              <Text css={styles.caption}>of miles spent speeding</Text>
            </Flex>
          )}
          {!!item.averageSpeedExceedencePercentage && (
            <Flex css={styles.speedPercentages}>
              <Text tag="h2" css={styles.largeText} data-testid={WORST_SPEEDER_ITEM_DTI.AVG_EXCEEDANCE}>
                {formatPercentage(item.averageSpeedExceedencePercentage, 1)}
              </Text>
              <Text css={styles.caption}>avg speed limit exceedance</Text>
            </Flex>
          )}
        </Box>
      </Flex>
    </Link>
  </BasicListItem>
)
